import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { VersionCheckService } from '../services/version-check.service';

const VERSION_HEADER = 'X-App-Version';

@Injectable()
export class VersionHeaderInterceptor implements HttpInterceptor {
  constructor(private _versionCheck: VersionCheckService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const serverVersion = event.headers.get(VERSION_HEADER);
          // TODO: remove debug logging once version-header flow is verified
          console.log('[VersionHeaderInterceptor]', {
            url: request.url,
            status: event.status,
            serverVersion,
            allHeaderKeys: event.headers.keys()
          });
          this._versionCheck.reportServerVersion(serverVersion);
        }
      })
    );
  }
}
